module.exports = __webpack_public_path__ + "img/icon.min.737cdd03.png";